import { Grid, Stack } from '@mui/material';

import useFlexBoxStyles from 'common/flexBox';
import EventFormAssetsItem from './EventFormAssetsItem';
import EventFormCollapse from './common/EventFormCollapse';
import EventItemCarousel from './common/EventItemCarousel';

const EventFormAssetsRender = (props) => {
    const {
        sectionTitle,
        hideAdd,
        assets = [],
        editButton,
        editAsset,
        selectAsset,
        addButtonText,
        deleteAsset,
        expanded,
        assetsType,
        deleteButton = true,
    } = props;

    const { classes: flexBox } = useFlexBoxStyles();

    return (
        <Stack direction="column" className={flexBox.marginTop1}>
            <EventFormCollapse
                hideAdd={hideAdd}
                hideExpand={!assets?.length}
                expanded={expanded}
                sectionTitle={sectionTitle}
                selectAsset={selectAsset}
                addButtonText={addButtonText}
                canExpand={assets.length > 0}
            >
                <EventItemCarousel upcomingLength={assets?.length}>
                    <Grid container spacing={1} wrap="nowrap">
                        {assets.map((asset, idx) => {
                            return (
                                <Grid key={idx} item lg={3} sm={6}>
                                    <EventFormAssetsItem
                                        asset={{ ...((assetsType && { type: assetsType }) || {}), ...asset }}
                                        editAsset={(newAsset) => editAsset(newAsset, idx)}
                                        deleteAsset={deleteAsset}
                                        deleteButton={deleteButton}
                                        editButton={editButton}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                </EventItemCarousel>
            </EventFormCollapse>
        </Stack>
    );
};

export default EventFormAssetsRender;
